import axios from "@/axios.js";
import ActionTypes from "./action_types_service";

export default {
  getAllActionTypes({ commit }, item) {
    return new Promise((resolve, reject) => {
      ActionTypes.getAllActionTypes(item, (rows, lastRow) => {
        // // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchActionTypes(context, action_typeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/action_types/action_types/${action_typeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeActionType(context, action_typeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/action_types/action_types/${action_typeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingActionTypeLists(context, action_type_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/action_types/action_types/get_existing_action_type_lists/${action_type_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingActionTypeLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/action_types/action_types/search_existing_action_type_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateActionTypes({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/action_types/action_types/update_action_type", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addActionTypes({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/action_types/action_types/add_action_types", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeActionTypes({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/action_types/action_types/${roleId}`)
        .then(response => {
          commit("REMOVE_STEPS", roleId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
